var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempNotificacao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 394,
    viewBox: "0 0 182 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 394,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6501,
    y: 180.287,
    width: 154.785,
    height: 60.0956,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 228.546,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 193.035,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 206.692,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6501,
    y: 96.5176,
    width: 154.785,
    height: 66.8013,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 133.85,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 121.103,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 152.061,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 108.354,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 270.431,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6501,
    y: 255.862,
    width: 154.785,
    height: 51.9008,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9402,
    y: 293.194,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempNotificacao);
export default __webpack_public_path__ + "static/media/TempNotificacao.5844adf3463022dc56212763c27f9edb.svg";
export { ForwardRef as ReactComponent };